const combineInt8Array = (a: Uint8Array, b: Uint8Array, offset: number) => {
  a.set(b, offset);
};

const byteToInt32 = (byte: Uint8Array, offset: number) => {
  return (
    (byte[offset] & 255) +
    ((byte[offset + 1] & 255) << 8) +
    ((byte[offset + 2] & 255) << 16) +
    ((byte[offset + 3] & 255) << 24)
  );
};

const byteToInt16 = (byte: Uint8Array, offset: number) => {
  return (byte[offset] & 255) + ((byte[offset + 1] & 255) << 8);
};

export { combineInt8Array, byteToInt32, byteToInt16 };
